import { dataAppsSettingsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAppsSettingsSolid = /*#__PURE__*/createIcon(dataAppsSettingsSolid)
export default IconAppsSettingsSolid
